export function parseCardReferencePayload(value) {
  if (!value) return null;
  try {
    const parsed = typeof value === "string" ? JSON.parse(value) : value;
    const cardId = `${parsed?.cardId || parsed?.id || ""}`.trim();
    if (!cardId) return null;
    return {
      cardId,
      boardId: `${parsed?.boardId || ""}`.trim(),
      boardSlug: `${parsed?.boardSlug || ""}`.trim(),
      boardName: `${parsed?.boardName || ""}`.trim(),
      deckId: `${parsed?.deckId || ""}`.trim(),
      type: `${parsed?.type || ""}`.trim().toLowerCase() === "stack" ? "stack" : "card",
      title: `${parsed?.title || ""}`.trim(),
      description: `${parsed?.description || ""}`.trim(),
      lifecycleState: `${parsed?.lifecycleState || ""}`.trim(),
      status: `${parsed?.status || ""}`.trim(),
      template: `${parsed?.template || ""}`.trim(),
      subcardCount: Number(parsed?.subcardCount) || 0,
      stackCardCount: Number(parsed?.stackCardCount) || 0,
    };
  } catch (_) {
    return null;
  }
}

export function getCardReferenceFromDataTransfer(dataTransfer) {
  if (!dataTransfer) return null;
  const customRef =
    dataTransfer.getData("application/x-uniflo-card-reference") ||
    dataTransfer.getData("text/uniflo-card-reference");
  const parsed = parseCardReferencePayload(customRef);
  if (parsed) return parsed;

  const cardId = `${dataTransfer.getData("text/uniflo-card-id") || ""}`.trim();
  if (!cardId) return null;
  return {
    cardId,
    boardId: `${dataTransfer.getData("text/uniflo-card-board-id") || ""}`.trim(),
    boardSlug: `${dataTransfer.getData("text/uniflo-card-board-slug") || ""}`.trim(),
    boardName: `${dataTransfer.getData("text/uniflo-card-board-name") || ""}`.trim(),
    deckId: `${dataTransfer.getData("text/uniflo-card-source-deck-id") || ""}`.trim(),
    type: "card",
    title: "",
    description: "",
    lifecycleState: "",
    status: "",
    template: "",
    subcardCount: 0,
    stackCardCount: 0,
  };
}

export function hasCardReferenceDrag(dataTransfer) {
  const types = Array.from(dataTransfer?.types || []);
  return (
    types.includes("application/x-uniflo-card-reference") ||
    types.includes("text/uniflo-card-reference") ||
    types.includes("text/uniflo-card-id")
  );
}

export function formatCardReferenceMeta(ref) {
  const parts = [];
  parts.push(ref?.type === "stack" ? "Stack" : "Card");
  const count =
    ref?.type === "stack"
      ? Number(ref?.stackCardCount) || 0
      : Number(ref?.subcardCount) || 0;
  if (count > 0) {
    parts.push(
      `${count} ${ref?.type === "stack" ? "card" : "subcard"}${count === 1 ? "" : "s"}`
    );
  }
  const state = `${ref?.lifecycleState || ref?.status || ""}`.trim();
  const normalizedState = state.toLowerCase();
  if (normalizedState === "active") return parts.join(" / ");
  if (state) parts.push(state);
  return parts.join(" / ");
}

export function openWorkspaceCardReference(cardRef) {
  const cardId = `${cardRef?.cardId || cardRef?.id || ""}`.trim();
  if (!cardId || typeof window === "undefined") return false;
  const event = new CustomEvent("uniflo:open-workspace-card", {
    cancelable: true,
    detail: {
      ...cardRef,
      cardId,
    },
  });
  window.dispatchEvent(event);
  return event.defaultPrevented;
}

export function normalizeCardReferenceList(value) {
  if (!Array.isArray(value)) return [];
  return value.map((entry) => parseCardReferencePayload(entry)).filter(Boolean);
}
